import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=93e9427c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=93e9427c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e9427c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93e9427c')) {
      api.createRecord('93e9427c', component.options)
    } else {
      api.reload('93e9427c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=93e9427c&scoped=true&", function () {
      api.rerender('93e9427c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/comp/PopupBox.vue"
export default component.exports